<template>
  <PriceRescueToastRegion
    close-button-class="pr-toast-close"
    dismiss-label="x"
    icon-class="pr-status-icon"
    region-class="pr-toast-region"
    toast-class="pr-toast"
    toast-tone-class-prefix="pr-toast"
    :toasts="toasts.toasts"
    @dismiss="toasts.dismiss"
  />
</template>

<script setup lang="ts">
import { PriceRescueToastRegion } from "@price-rescue/ui-components";

import { useMerchantToastStore } from "../../features/shared-ui/toast-store.js";

const toasts = useMerchantToastStore();
</script>
